// @flow

import * as urls from '../urls';
import * as request from 'app/utils/request';

import type {TaggedItemType} from './types';

export const attachTagsFetcher = (taggedItems: Array<TaggedItemType>) => {
  return request.postJson(urls.TAGGEDITEMS_API_URL, taggedItems);
};

export const detachTagFetcher = (taggedItemURL: string) => {
  return request.del(taggedItemURL);
};

export const tagsListFetcher = (params: any) =>
  request.get(urls.TAGS_API_URL, params);
